import { createContext, useContext, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const addItem = (product) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.item_id === product.id);
      if (existing) {
        return prev.map((i) =>
          i.item_id === product.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [
        ...prev,
        {
          item_id: product.id,
          name: product.name,
          price_per_day: product.price_per_day,
          unit: product.unit,
          image: product.image,
          quantity: 1,
          days: 1,
        },
      ];
    });
    setOpen(true);
  };

  const removeItem = (id) => setItems((p) => p.filter((i) => i.item_id !== id));
  const updateQty = (id, quantity) =>
    setItems((p) => p.map((i) => (i.item_id === id ? { ...i, quantity: Math.max(1, quantity) } : i)));
  const updateDays = (id, days) =>
    setItems((p) => p.map((i) => (i.item_id === id ? { ...i, days: Math.max(1, days) } : i)));
  const clear = () => setItems([]);

  const subtotal = useMemo(
    () => items.reduce((s, i) => s + i.price_per_day * i.quantity * i.days, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, open, setOpen, addItem, removeItem, updateQty, updateDays, clear, subtotal, count }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
